import { RangeSlider, Badge, Group } from "@mantine/core";
import _ from "lodash";
import React from "react";
import FormReadOnlyField from "./formReadOnlyField";
import { isWidgetReadOnly } from "../helpers/formReadOnly";

const AgeRanger = ({
  form,
  name,
  label,
  defaultValue,
  min = 0,
  max = 100,
  step,
  readOnly = false,
  readonly = false,
  disabled = false,
  ...props
}) => {
  const rangeValue = _.get(form.values, name);
  const display =
    Array.isArray(rangeValue) && rangeValue.length === 2
      ? `${rangeValue[0]} - ${rangeValue[1]}`
      : `${min} - ${max}`;

  if (isWidgetReadOnly({ disabled, readOnly, readonly, form })) {
    return <FormReadOnlyField label={label} value={display} />;
  }

  return (
    <>
      <Group position="apart">
        {label}
        <Badge variant="dot">{display}</Badge>
      </Group>

      <RangeSlider
        mt={10}
        min={min}
        max={max}
        step={step}
        {...props}
        {...form.getInputProps(name, { type: props.type })}
        defaultValue={defaultValue}
      />
    </>
  );
};


export default AgeRanger